<template>
    <div  id="contralor-config" class="vs-con-loading__container">
        <vs-card>
            <vs-row vs-justify="center" vs-type="flex">
                <vs-col vs-w="6" vs-xs="12">
                    <label class="text-sm opacity-75">{{$t('initial_period')}}</label>
                    <v-select
                    @input="params.final_period = ''"
                        :options="periods"
                        v-model="params.initial_period"
                        :reduce="el => el.PeriodId"
                        label="WeekInvoice"
                        name="filterWeek"
                        class="mx-1"
                        
                    />
                </vs-col>
            </vs-row>
            <vs-row vs-justify="center" vs-type="flex">
                <vs-col vs-w="6" vs-xs="12">
                   <label class="text-sm opacity-75">{{$t('final_period')}}</label>
                    <v-select
                        :options="filteredPeriods"
                        v-model="params.final_period"
                        :reduce="el => el.PeriodId"
                        label="WeekInvoice"
                        name="filterWeek"
                        class="mx-1"
                    />
                </vs-col>
            </vs-row>
            <vs-row vs-justify="center" vs-type="flex">
                <vs-col vs-w="6" vs-sm="12">
                    <qb-upload textSize="18" text="Upload .pdf" ref="upload"  :showUploadButton="false"  :reset="resetFiles" @on-delete="handleDeleteFile" @update-file="handleUpdateFile" :limit="1" accept="application/pdf" />       
                </vs-col>
            </vs-row>
            <vs-row vs-justify="center" vs-type="flex">
                <vs-col vs-w="2" vs-xs="12">
                    <vs-button class="w-full mt-5" @click="submit" :disabled="isInvalid" >{{$t('generate')|capitalize}}</vs-button>
                </vs-col>
            </vs-row>
        </vs-card>
        <!-- <vs-card>
            <extra-files-table />
        </vs-card> -->
    </div>
</template>

<script>
import vSelect from 'vue-select'
import invoice from '@/http/requests/invoice'
import loading from '@/mixins/Loading'
import QbUpload from '@/components/upload/QbUpload.vue'
import ExtraFilesTable from './components/ExtraFilesTable.vue'

export default {
    //Instancias por order Alfabetico
    components:{
        ExtraFilesTable,
        QbUpload,
        vSelect
    },
    computed:{
        isLoading(){
            return this.loading.periods || this.loading.submit
        },
        isInvalid(){
            return this.params.final_period=='' ||  this.params.final_period==null || 
                   this.params.initial_period=='' ||  this.params.initial_period==null ||
                   this.params.pdf==''
        },
        filteredPeriods() {
            if (this.params.initial_period != null) {
                return this.periods.filter((item) => {
                    return (parseInt(item.PeriodId) >= parseInt(this.params.initial_period))
                });
            }
            return []
        },  
    },
    data() {
        return {
            loading:{
                periods:false,
                submit:false
            },
            params:{
                final_period:'',
                initial_period:'',
                pdf:''
            },
            periods:[],
            resetFiles:false
        }
    },
    methods: {
        init(){
            this.getPeriods()
        },
        getPeriods(){
            this.loading.periods=true
            invoice.getPeriodList().then(res => {
                this.periods = res.data.periodList
                this.loading.periods=false
            }).catch(err => {
                this.loading.periods=false
            })
        },
        handleDeleteFile(){
            this.params.pdf = ''
        },
        handleUpdateFile(e){
            this.params.pdf = e[0]
        },
        setDefaultParams(){
            this.params={
                    final_period:'',
                    initial_period:'',
                    pdf:''
                }
        },
        submit(){
             this.loading.submit=true
             let params = new FormData()
            params.append('initial_period', this.params.initial_period)
            params.append('final_period', this.params.final_period)
            params.append('pdf', this.params.pdf)

            invoice.storeExtraFiles(params).then(res => {
                this.loading.submit=false
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    text: 'Extra File Saved'
                })
                this.resetFiles=!this.resetFiles
                this.setDefaultParams()
            }).catch(err => {
                this.loading.submit=false
                if(err.response.status==422){
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Alert',
                        text: err.response.data.message
                    })
                }else{
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Alert',
                        text: 'SERVER ERROR'
                    })
                }
            })
        }
    },
    mounted() {
        this.init()
    },
    mixins:[loading],
    watch:{
        isLoading(val){
            if (val) {
                this.openLoading(`contralor-config`)
            } else {
                this.closeLoading(`contralor-config`)
            }
        }
    }
}
</script>

<style>

</style>